import { makePersisted } from "@solid-primitives/storage";
import { type Accessor, createSignal } from "solid-js";

type ChatsAuthorFilter = "mine" | "all";

const STORAGE_KEY = "chats-author-filter";

// Module-level singleton so the sidebar toggle and the main Chats page filter
// react to each other live, not just across reloads.
const [authorFilter, setAuthorFilter] = makePersisted(createSignal<ChatsAuthorFilter>("all"), {
  storage: typeof window !== "undefined" ? localStorage : undefined,
  name: STORAGE_KEY,
});

export const useChatsAuthorFilter = (): {
  authorFilter: Accessor<ChatsAuthorFilter>;
  setAuthorFilter: (v: ChatsAuthorFilter) => void;
} => ({
  authorFilter,
  setAuthorFilter: (v) => setAuthorFilter(v),
});
